/**
 * Condition node definitions.
 */

import type { NodeDefinition } from '../types';
import { deviceConditionDefinition } from './device-condition';
import { triggerDefinition } from './trigger';
import { mathConditionDefinition } from './math-condition';

export const conditionDefinitions: [string, NodeDefinition][] = [
	['condition', deviceConditionDefinition],
	['trigger', triggerDefinition],
	['mathCondition', mathConditionDefinition],
];
